import ReactQuill from 'react-quill';

const Embed = ReactQuill.Quill.import('blots/block/embed');

export class HR extends Embed {
  static create(value) {
    let node = super.create(value);
    // give it some margin
    node.setAttribute('style', 'height:0px; margin-top:10px; margin-bottom:10px;');
    return node;
  }
}

HR.blotName = 'hr'; //now you can use .ql-hr classname in your toolbar
HR.className = 'my-hr';
HR.tagName = 'hr';

export const customHrHandler = quillRef => () => {
  const quill = quillRef.current.getEditor();

  const range = quill.getSelection();

  let position = range ? range.index : 0;

  if (position) {
    quill.insertEmbed(position, 'hr', 'null');
  }
};
